import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Facebook, ExternalLink } from 'lucide-react';

export const Footer = () => {
  const [logoError, setLogoError] = useState(false);

  return (
    <footer className="bg-[#F8F9FA] border-t border-gray-200 mt-12 sm:mt-16 md:mt-20">
      <div className="container-custom py-8 sm:py-10 md:py-12 px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {/* Brand */}
          <div className="space-y-3 sm:space-y-4">
            <img src="/Logotype.svg" alt="NIS2 Ochrana" className="h-10 sm:h-12 md:h-12" />
            <p className="text-xs sm:text-sm md:text-base text-gray-600 leading-relaxed">
              Profesionální řešení pro zajištění compliance s NIS2 směrnicí EU.
            </p>
          </div>

          {/* Menu */}
          <div>
            <h3 className="text-base sm:text-lg md:text-xl font-semibold mb-3 sm:mb-4 text-[#0A0F1F]">Menu</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/blog" className="text-xs sm:text-sm md:text-base text-gray-600 hover:text-[#2A4CFF] transition-colors block py-1">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/o-nas" className="text-xs sm:text-sm md:text-base text-gray-600 hover:text-[#2A4CFF] transition-colors block py-1">
                  O nás
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-xs sm:text-sm md:text-base text-gray-600 hover:text-[#2A4CFF] transition-colors block py-1">
                  Kontakt
                </Link>
              </li>
              <li>
                <Link to="/souhlas-se-zpracovanim-osobnich-udaju" className="text-xs sm:text-sm md:text-base text-gray-600 hover:text-[#2A4CFF] transition-colors block py-1 leading-tight">
                  Souhlas se zpracováním osobních údajů
                </Link>
              </li>
            </ul>
          </div>

          {/* Kontakt */}
          <div>
            <h3 className="text-base sm:text-lg md:text-xl font-semibold mb-3 sm:mb-4 text-[#0A0F1F]">Kontakt</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li className="flex items-start gap-2 sm:gap-3">
                <Mail className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-[#2A4CFF] mt-0.5 flex-shrink-0" />
                <a href="mailto:info@nis2ochrana.cz" className="text-xs sm:text-sm md:text-base text-gray-600 hover:text-[#2A4CFF] transition-colors break-all">
                  info@nis2ochrana.cz
                </a>
              </li>
              <li className="flex items-start gap-2 sm:gap-3">
                <Phone className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-[#2A4CFF] mt-0.5 flex-shrink-0" />
                <a href="tel:+420777963653" className="text-xs sm:text-sm md:text-base text-gray-600 hover:text-[#2A4CFF] transition-colors">
                  +420 777 963 653
                </a>
              </li>
            </ul>
          </div>

          {/* O aplikaci */}
          <div>
            <h3 className="text-base sm:text-lg md:text-xl font-semibold mb-3 sm:mb-4 text-[#0A0F1F]">O aplikaci</h3>
            <p className="text-xs sm:text-sm md:text-base text-gray-600 mb-3 sm:mb-4">Aplikaci vyvinula společnost</p>
            <a 
              href="https://www.rascasone.com/cs" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mb-3 sm:mb-4 group"
            >
              {logoError ? (
                <span className="text-xs sm:text-sm font-semibold text-[#0A0F1F] group-hover:text-[#2A4CFF] transition-colors">
                  Rascasone s.r.o.
                </span>
              ) : (
                <img 
                  src="/rascasone-logo.svg" 
                  alt="Rascasone s.r.o." 
                  className="h-7 sm:h-8 w-auto opacity-100 transition-opacity"
                  loading="lazy"
                  onError={() => setLogoError(true)}
                />
              )}
              <ExternalLink className="w-3 h-3 text-gray-400 group-hover:text-[#2A4CFF] transition-colors flex-shrink-0" />
            </a>
            <ul className="space-y-1 text-xs sm:text-sm text-gray-600">
              <li>IČ: 06286569</li>
              <li>DIČ: CZ06286569</li>
              <li className="pt-1 sm:pt-2">Spisová značka: C 279510</li>
              <li>Městský soud v Praze</li>
              <li className="pt-1 sm:pt-2">Prosecká 527/24, Libeň</li>
              <li>180 00 Praha</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-300 mt-6 sm:mt-8 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-6">
            <p className="text-xs sm:text-sm md:text-base text-gray-600 text-center sm:text-left">
              © 2025 Rascasone, s.r.o. Všechna práva vyhrazena.
            </p>
            
            <div className="flex items-center gap-3 sm:gap-4">
              <span className="text-xs sm:text-sm md:text-base text-gray-600">Sledujte nás</span>
              <a 
                href="https://www.linkedin.com/company/nis2-ochrana" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-[#2A4CFF] transition-colors p-1"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5 sm:w-6 sm:h-6" />
              </a>
              <a 
                href="https://www.facebook.com/NIS2Ochrana" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-[#2A4CFF] transition-colors p-1"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5 sm:w-6 sm:h-6" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};